/**
 * Error codes returned by the API that should be mapped to user-friendly messaging.
 */
export enum ERROR_TYPE {
  MOBILE_NO_ALREADY_EXIST = "MOBILE_NO_ALREADY_EXIST",
  RESERVED_NAME = "RESERVED_NAME",
  BANNED_NAME = "BANNED_NAME",
}

/**
 * Available authentication entry points.
 */
export enum USER_LOGIN_TYPE {
  EMAIL = "EMAIL",
  MOBILE = "MOBILE",
  EMAIL_SIGNIN = "EMAIL_SIGNIN",
}

/**
 * Static content categories resolved from the CMS.
 */
export enum CONTENT_TYPE {
  FAQ = "FAQ",
  TERMS = "TERMS",
  SUPPORT = "TERMS",
  PRIVACY = "PRIVACY",
}

/**
 * Author types for announcements.
 */
export enum ANNOUNCER_TYPE {
  ADMIN = "ADMIN",
  MANUFACTURER_USER = "MANUFACTURER_USER",
}

/**
 * Identifier for the user creating a support ticket.
 */
export enum SUPPORT_USER_TYPE {
  ADMIN = "ADMIN",
  MANUFACTURE = "MANUFACTURE",
}

/**
 * Available compound groupings displayed in product details.
 */
export enum COMPOUND_TYPE {
  TERPENE = "terpenes",
  CANNABINOID = "cannabinoids",
}

/**
 * Zendesk dynamic dropdown field identifiers used when creating tickets.
 */
export enum ZENDESK_IDS {
  CONSUMER_PLATFORM = "42490766207123",
  BROWSER = "42504998359571",
  DEVICE_MANUFACTURER = "42504866028691",
  DEVICE_TYPE = "42504524989331",
  LOGGEDIN = "42503847160339",
  SUPPORT_REASON = "41546925688595",
  SERIAL_NUMBER = "42505349110035",
  PHONE_NUMBER = "42473495489939",
  OPERATING_SYSTEM = "43210825562515",
}

/**
 * Bucket types shown in batch rating views.
 */
export enum BATCH_RATING_TYPE {
  THIS_BATCH = "THIS_BATCH",
  PREVIOUS_BATCH = "PREVIOUS_BATCH",
}

/**
 * External laboratory or regulatory platforms data may originate from.
 */
export enum DATA_PLATFORM_TYPE {
  CLIMS = "CLIMS",
  METRC = "METRC",
  NORDIC_ANALYTICAL = "NORDIC_ANALYTICAL",
}

export enum RIBBON_CRITERIA_TYPE {
  COLLECT_PRODUCT = "Collect Product",
  PROVIDE_REVIEW = "Provide Review",
  PROVIDE_STAR_RATING = "Provide Star Rating",
}
